//#region Angular Imports

import { IServiceProvider } from "angular"

//#endregion

import { DataExporter, ExportDataMethod } from "./export.data-exporter"

//#region Public Types

export const EXPORT_SERVICE_NAME = 'exportService'
export const EXPORT_SERVICE_PROVIDER_NAME = 'exportServiceProvider'

//#endregion

export class ExportService {

    // #region Ctor

    public constructor() { }

    // #endregion

    //#region Data Exporter

    public createDataExporter(method: ExportDataMethod): DataExporter {
        return new DataExporter(method)
    }

    //#endregion
}

export class ExportServiceProvider
    implements IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [() => {
        return new ExportService()
    }]

    //#endregion
} 
